import React, { Component } from 'react'
import { resetPasswordRequest } from '../../services/User';
import Formsy from 'formsy-react'
import { Grid} from 'semantic-ui-react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox'
import fieldEmailIcon from '../../assets/images/newui/field-email-icon.png'
import servicegrace from '../../assets/images/newui/servicegrace.svg'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import '../SignInContainer/SignInContainerNew.less'
import GeneralMessage from '../../components/GeneralMessage/GeneralMessage';

const initialState = {
    isLoading: false,
    email: '',
    windowWidth: 0,
    message: '',
    messageType: 'error',
    disableGoButton: false
}
class PasswordResetRequestContainerNew extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    }

    componentDidMount() {
        //pageView('reset-password-request');
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        
    }

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value, disableGoButton: false });
    }

    

    onValidSubmit = async () => {
        try {
            const { email } = this.state;
            this.setState({ isLoading: true });
            const response = await resetPasswordRequest(email);

            if (response.resStatus >= 400) {

                await this.setState({
                    message: response.message || 'Error while requesting reset password.',
                    messageType: 'error'
                })


            } else {
                await this.setState({
                    message: response.message || 'An email has been sent to given email, please follow instructions.',
                    messageType: 'success',
                    disableGoButton: true
                })
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.setState({ isLoading: false });
        }
    };
    redirectToSignIn = () => {
        this.props.history.push('/signin');
    }
    render() {
        return (
            
           
            <div className='small-form-container'>
                <img src={servicegrace} />
                <div className='small-form-heading'>ServiceGrace</div>
                <div className='small-form-sub-heading'>Reset Password Request</div>
                {!_.isEmpty(this.state.message) && <GeneralMessage type={this.state.messageType} message={this.state.message} />}
                <Formsy onValidSubmit={this.onValidSubmit} className='small-form-form'>
                    <Grid>
                    <Grid.Column width={16} >
                                            <DGTextbox name="email" label="Email" placeholder="Ex: example@email.com" required type="email"
                                                tabIndex={3}
                                                icon={fieldEmailIcon}
                                                maxLength={100}
                                                validations={{
                                                    isEmail: true,
                                                    maxLength: 100
                                                }}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',
                                                    maxLength: 'Email should not exceed 100 characters.',
                                                    isEmail: 'Enter a valid email.'
                                                }}
                                                onChange={this.handleChange}
                                            />


                                        </Grid.Column>


                        
                        
                        <button className='small-form-submit' tabIndex={6} type='submit'>GO <img src={next} /></button>

                    </Grid>
                </Formsy>
            </div>

        )
    }
}

function mapStateToProps({ buyer }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        buyerFormData: buyer

    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

        
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetRequestContainerNew);
